import * as React from "react"
import {Box} from "@mui/material";
import {formatDate} from "@ui-seeker/utils"

import {DATE_METRICS} from "@constants";


export default function dateColumn(tableMetric) {
	const isDailyMetric = tableMetric === DATE_METRICS.DAILY

	return {
		name: "date", label: 'Date',
		options: {
			filterOptions: {
				renderValue: v => isDailyMetric ? formatDate(v, { isString: true }) : v
			},
			customBodyRowRenderLite: value => <Box display="flex" justifyContent="center">
				{isDailyMetric ? formatDate(value, { isString: true }) : value}
			</Box>
			
		}
	}
}